import { useEffect } from 'react';

export const usePageMetadata = (title: string, description: string, noIndex = false) => {
  useEffect(() => {
    const previousTitle = document.title;
    const descriptionElement = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    const previousDescription = descriptionElement?.content;
    const meta = descriptionElement ?? document.createElement('meta');
    meta.name = 'description';
    meta.content = description;
    if (!descriptionElement) document.head.append(meta);
    const robotsElement = document.querySelector<HTMLMetaElement>('meta[name="robots"]');
    const previousRobots = robotsElement?.content;
    const robots = robotsElement ?? document.createElement('meta');
    robots.name = 'robots';
    robots.content = noIndex ? 'noindex' : 'index, follow';
    if (!robotsElement) document.head.append(robots);
    document.title = title;

    return () => {
      document.title = previousTitle;
      if (previousDescription !== undefined) meta.content = previousDescription;
      else meta.remove();
      if (previousRobots !== undefined) robots.content = previousRobots;
      else robots.remove();
    };
  }, [title, description, noIndex]);
};
